import SecretIcon from '@/assets/images/common/svg/secret.svg?react';
import styles from './index.module.scss';

const SysEncrypt = () => {
  return (
    <div className={styles.sysEncrypt}>
      <div className={styles.secretIcon}>
        <SecretIcon />
      </div>
      Messages and calls are end-to-end encrypted. No one outside of this chat, not even
      Halo App, can read or listen to them.
      {/* <a>Tap to learn more.</a> */}
    </div>
  );
};

export default SysEncrypt;
